export const fieldNames = {
  name: 'Name',
  type: 'Type',
  vendor: 'Vendor',
  firmReference: 'Internal Reference',
  docLink: 'Document Link',
  businessArea: 'Primary Business Area',
  lastAttestedAt: 'Last Attested At',
  lastAttestedBy: 'Last Attested By',
  status: 'Status',
  technology: 'Technology',
  dataObject: 'Data Object',
  source: 'Application', //source or target application
  direction: 'Direction',
  periodicity: 'Periodicity',
  description: 'Description',
  email: 'Email',
  password: 'Password'
}

export const typeOptions = [
  {
    text:'EUC',
    value: 'euc'
  },
  {
    text:'Internal',
    value: 'internal'
  },
  {
    text:'External',
    value: 'external'
  }
]

export const statusOptions = [
  {
    text:'New',
    value: 'new'
  },
  {
    text:'Approved',
    value: 'approved'
  },
  {
    text:'Proposed',
    value: 'proposed'
  },
  {
    text:'Inactive',
    value: 'inactive'
  }
]

export const creationTypes = [
  {
    text:'Adjustment',
    value: 'adjustment'
  },
  {
    text:'Derivation',
    value: 'derivation'
  },
  {
    text:'Enrichment',
    value: 'enrichment'
  },
  {
    text:'Manual entry',
    value: 'manual-entry'
  }
]

export const directions = [
  {
    text:'In',
    value: 'in'
  },
  {
    text:'Out',
    value: 'out'
  }
]

export const periods = [
  {
    text:'Daily',
    value: 'daily'
  },
  {
    text:'Intraday',
    value: 'intraday'
  },
  {
    text:'Monthly',
    value: 'monthly'
  },
  {
    text:'Real time',
    value: 'real-time'
  },
  {
    text:'Weekly',
    value: 'weekly'
  }
]

export const flowStatuses = [
  {
    text:'New',
    value: 'new'
  },
  {
    text:'Alleged against source',
    value: 'alleged-against-source'
  },
  {
    text:'Alleged against target',
    value: 'alleged-against-target'
  },
  {
    text:'Confirmed',
    value: 'confirmed'
  },
  {
    text:'Challenge source',
    value: 'challenge-source'
  },
  {
    text:'Challenge target',
    value: 'challenge-target'
  },
  {
    text:'Rescinded',
    value: 'rescinded'
  }
]